export interface BalanceTransaction {
  Timestamp: string;
  Operation: number;
  Amount: number;
  Balance: number;
  Properties: {
    Purpose: string;
    PaymentPurpose: string; // исходный тип из базы
    Description?: string;
    Origin?: string; // кто сделал (username пользователя)
  };
}

export interface ForUser {
  userId: string;
  deviceId?: never;
}

export interface ForDevice {
  deviceId?: string;
  userId?: never;
}

export enum ServiceCode {
  MONI_PRO = 'MONI_PRO',
  MOBILE_APP = 'MOBILE_APP',
  HWT = 'HWT'
}
